module.exports = require("@oddbird/css-anchor-positioning/fn");